module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/shared/main/energy/energy.component.html
// module id = ./src/app/components/calculator/calculator-item/shared/main/energy/energy.component.html
// module chunks = main